import { queries } from '../lib/supabase/queries';

export const enquiriesService = {
  // Public insert function
  async submitEnquiry(enquiry) {
    return queries.enquiries.submit(enquiry);
  },

  // Admin read/management functions
  async getAll(statusFilter = 'all') {
    return queries.enquiries.getAll(statusFilter);
  },

  async updateStatus(id, status, adminNotes = null) {
    return queries.enquiries.updateStatus(id, status, adminNotes);
  },

  async delete(id) {
    return queries.enquiries.delete(id);
  },
};

export default enquiriesService;
